/* Anyra hero controller. No dependency on Swiper: the hero is the largest
   contentful paint on every page-one session and every kilobyte here is
   measured against the speed budget. */
class AnyraHero extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-anyra-track]');
    this.slides = Array.from(this.querySelectorAll('[data-anyra-slide]'));
    this.dots = Array.from(this.querySelectorAll('[data-anyra-dot]'));
    this.live = this.querySelector('[data-anyra-live]');
    if (!this.track || this.slides.length < 2) { this.hideControls(); return; }

    this.index = 0;
    this.delay = parseInt(this.dataset.autoplay || '0', 10);
    this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    this.querySelector('[data-anyra-prev]')?.addEventListener('click', () => this.step(-1, true));
    this.querySelector('[data-anyra-next]')?.addEventListener('click', () => this.step(1, true));
    this.dots.forEach((d, i) => d.addEventListener('click', () => this.go(i, true)));

    this.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') { this.step(-1, true); }
      if (e.key === 'ArrowRight') { this.step(1, true); }
    });

    // Pause while the visitor is reading or interacting.
    ['mouseenter', 'focusin', 'touchstart'].forEach(ev => this.addEventListener(ev, () => this.stop(), { passive: true }));
    ['mouseleave', 'focusout'].forEach(ev => this.addEventListener(ev, () => this.start()));
    document.addEventListener('visibilitychange', () => document.hidden ? this.stop() : this.start());

    this.bindSwipe();
    this.go(0, false);
    this.start();
  }

  disconnectedCallback() { this.stop(); }

  hideControls() {
    this.querySelector('[data-anyra-arrows]')?.remove();
    this.querySelector('[data-anyra-dots]')?.remove();
  }

  bindSwipe() {
    let x0 = null;
    this.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
    this.addEventListener('touchend', (e) => {
      if (x0 === null) return;
      const dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 45) this.step(dx < 0 ? 1 : -1, true);
      x0 = null;
    }, { passive: true });
  }

  step(dir, manual) { this.go((this.index + dir + this.slides.length) % this.slides.length, manual); }

  go(i, manual) {
    this.index = i;
    this.track.style.transform = `translate3d(${-i * 100}%,0,0)`;
    this.slides.forEach((s, n) => {
      const on = n === i;
      s.setAttribute('aria-hidden', on ? 'false' : 'true');
      // Keep off-screen slides out of the tab order.
      s.querySelectorAll('a,button').forEach(el => el.tabIndex = on ? 0 : -1);
    });
    this.dots.forEach((d, n) => d.setAttribute('aria-current', n === i ? 'true' : 'false'));
    if (this.live) this.live.textContent = `Slide ${i + 1} of ${this.slides.length}`;
    if (manual) { this.stop(); this.start(); }
  }

  start() {
    if (!this.delay || this.reduced || document.hidden) return;
    this.stop();
    this.timer = setInterval(() => this.step(1, false), this.delay);
  }

  stop() { clearInterval(this.timer); }
}
customElements.define('anyra-hero', AnyraHero);
